import { render } from "./CalendarBanner.vue?vue&type=template&id=e25f0022&scoped=true"
import script from "./CalendarBanner.vue?vue&type=script&lang=js"
export * from "./CalendarBanner.vue?vue&type=script&lang=js"

import "./CalendarBanner.vue?vue&type=style&index=0&id=e25f0022&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-e25f0022"

export default script